import { Icon } from '@mondra/ui-components'
import { FC } from 'react'
import { NavLink } from 'react-router-dom'
import { ROUTES } from '../../const'

const menuItemClass = ({ isActive }: { isActive: boolean }) =>
  isActive ? 'menu-items-item menu-items-active' : 'menu-items-item'

const FoodNav: FC = () => {
  const {
    emissionFactors,
    generics,
    packaging,
    processedIngredients,
    processingActivity,
    produce,
    product,
    saleActivity,
    specialIngredients,
    storageActivity,
    transportActivity,
  } = ROUTES

  return (
    <>
      <NavLink to={processingActivity} className={menuItemClass}>
        <Icon type="processing" /> Processing
      </NavLink>
      <NavLink to={storageActivity} className={menuItemClass}>
        <Icon type="map" /> Storage
      </NavLink>
      <NavLink to={saleActivity} className={menuItemClass}>
        <Icon type="sale" /> Sales
      </NavLink>
      <NavLink to={packaging} className={menuItemClass}>
        <Icon type="packaging" /> Packaging
      </NavLink>
      <NavLink to={transportActivity} className={menuItemClass}>
        <Icon type="deliveryTruck" /> Transport
      </NavLink>
      <NavLink to={emissionFactors} className={menuItemClass}>
        <Icon type="waterPollutionImpact" /> Emission Factors
      </NavLink>
      <NavLink to={generics} className={menuItemClass}>
        <Icon type="butterfly" /> Generics
      </NavLink>
      <br />
      <hr />
      <h4 className="mb-3 ml-3 mt-5">Taxonomies</h4>
      <NavLink to={processedIngredients} className={menuItemClass}>
        <Icon type="ingredients" /> Processed Ingredients
      </NavLink>
      <NavLink to={specialIngredients} className={menuItemClass}>
        <Icon type="butterfly" /> Special Ingredients
      </NavLink>
      <NavLink to={produce} className={menuItemClass}>
        <Icon type="produce" /> Produce
      </NavLink>
      <NavLink to={product} className={menuItemClass}>
        <Icon type="product" /> GPC (Product)
      </NavLink>
    </>
  )
}

export default FoodNav
